module.exports = __webpack_public_path__ + "static/media/7.b48aed7d.svg";